module.exports = __webpack_public_path__ + "img/map.b8ab6232.png";